<template>
  <div ref="feature-container" class="my-6 md:my-0 transform hover:scale-105 transition-all duration-700 cursor-pointer"
       @click="onClick">
    <feature-title :title="'Värviline ja animatsiooniline'" :is-selected="isSelected"/>
    <div class="rounded-md">
      <div class="flex flex-wrap items-center justify-center">
        <div class="feature-wrapper rounded-md shadow-md w-full">
          <div class="frame">
            <div class="loader">
              <div class="loader-ring"></div>
              <div class="rocket-wrapper">
                <div class="trail-wrapper">
                  <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/61488/trail.png" alt="" class="trail" />
                </div>
                <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/61488/small-rocket.png" alt="" class="rocket" />
              </div>

              <div class="clouds-wrapper">

                <svg class="clouds" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 92 90.83">
                  <defs>
                    <clipPath id="clip-path" transform="translate(1.75)">
                      <circle cx="42.5" cy="42.5" r="42.5" fill="none" />
                    </clipPath>
                    <filter id="goo" color-interpolation-filters="sRGB">
                      <feGaussianBlur in="SourceGraphic" stdDeviation="6" result="blur" />
                      <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -11" result="goo" />
                      <feBlend in="SourceGraphic" in2="goo" />
                    </filter>
                    <filter id="blurMe">
                      <feGaussianBlur in="SourceGraphic" stdDeviation="0.9" />
                    </filter>
                  </defs>
                  <g clip-path="url(#clip-path)" fill="#eef2f3" filter="url(#goo)">
                    <g class="clouds-wrapper" filter="url(#blurMe)">
                      <ellipse class="cloud" cx="40" cy="61.83" rx="7" ry="7" />
                      <ellipse class="cloud" cx="81" cy="68.83" rx="8" ry="8" />
                      <ellipse class="cloud" cx="6" cy="63.83" rx="6" ry="6"/>
                      <ellipse class="cloud" cx="15" cy="70.83" rx="11" ry="11"  />
                      <ellipse class="cloud" cx="65" cy="74.83" rx="11" ry="11"  />
                      <ellipse class="cloud" cx="48" cy="71.83" rx="14" ry="14" />
                      <ellipse class="cloud" cx="34" cy="75.83" rx="16" ry="16" />
                    </g>
                  </g>
                </svg>

              </div>

            </div>
          </div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {gsap} from 'gsap'
import calculatorFeature from "@/mixins/calculatorFeature";
import FeatureTitle from "@/components/calculator-steps/utils/FeatureTitle";
export default {
  name: "ColorAndAnimations",
  mixins: [calculatorFeature],
  components: {
    FeatureTitle
  },
  mounted(){
    const tl = gsap.timeline({repeat: -1, repeatDelay: 0});

    tl.from('.cloud', {alpha: 0, duration: 1})
        .to('.rocket-wrapper',  { y: -400, ease:'Expo.easeIn', duration: 3 })
        .to('.cloud',  { attr:{ cy: 185}, ease:'Expo.easeIn' , duration: 3}, "-=3")
        .set('.cloud', {clearProps:"all"})
        .set('.rocket-wrapper', { y: 450 })
        .to('.rocket-wrapper', { y:0, ease:'Elastic.easeOut.config(0.5, 0.4)', duration: 4 })
        .to('.trail-wrapper', { scaleX:0.5, scaleY:0, alpha:0, ease:'Expo.easeOut', duration: 2.5 }, "-=2.0")
  }
}
</script>

<style scoped>

.feature-wrapper {
  height: 300px;
}

.frame {
  position: absolute;
  width: 100%;
  height: 300px;
  background-color: #08222e;
  overflow: hidden;
  border-radius: 5px;
}

.loader {
  position: absolute;
  width: 105px;
  left: calc(50% - 52px);
  top: calc(50% - 52px);
  -webkit-animation: fadeIn 2s;
  animation: fadeIn 2s;
}

.loader-ring {
  background: url("https://s3-us-west-2.amazonaws.com/s.cdpn.io/61488/loader-stars.jpg") no-repeat center center;
  background-size: 95px 95px;
  width: 105px;
  height: 105px;
  border-radius: 50%;
  border: 10px solid #d81f44;
}

.rocket-wrapper {
  position: absolute;
  left: 34px;
  top: -30px;
  height: 200px;
}

.rocket {
  width: 37px;
  height: auto;
}

.trail-wrapper {
  position: absolute;
  top: 78px;
  left: 13px;
  width: 12px;
  height: 44px;
  -webkit-transform: none;
  transform: none;
  -webkit-transform-origin: top center;
  transform-origin: top center;
  z-index: -1;
}

.trail {
  width: 12px;
  height: auto;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: jet 0.02s ease alternate infinite;
  animation: jet 0.02s ease alternate infinite;
  -webkit-transform-origin: top center;
  transform-origin: top center;
}

.clouds-wrapper {
  position: absolute;
  top: 13px;
  left: 10px;
  width: 88px;
  height: 85px;
}

.clouds {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 92px;
}

.cloud {
  -webkit-animation: kaboom 0.4s ease alternate infinite;
  animation: kaboom 0.4s ease alternate infinite;
  -webkit-transform-origin: center center;
  transform-origin: center center;
  opacity: 0.9;
}
.cloud:nth-child(odd) {
  -webkit-animation: kaboom 0.3s ease alternate infinite;
  animation: kaboom 0.3s ease alternate infinite;
}
.cloud:nth-child(1) {
  -webkit-animation-delay: 0.1s;
  animation-delay: 0.1s;
}
.cloud:nth-child(2) {
  -webkit-animation-delay: 0.2s;
  animation-delay: 0.2s;
}
.cloud:nth-child(3) {
  -webkit-animation-delay: 0.3s;
  animation-delay: 0.3s;
}
.cloud:nth-child(4) {
  -webkit-animation-delay: 0.4s;
  animation-delay: 0.4s;
}
.cloud:nth-child(5) {
  -webkit-animation-delay: 0.5s;
  animation-delay: 0.5s;
}
.cloud:nth-child(6) {
  -webkit-animation-delay: 0.6s;
  animation-delay: 0.6s;
}
.cloud:nth-child(7) {
  -webkit-animation-delay: 0.7s;
  animation-delay: 0.7s;
}

@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-webkit-keyframes kaboom {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  100% {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
  }
}
@keyframes kaboom {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  100% {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
  }
}
@-webkit-keyframes jet {
  0% {
    -webkit-transform: scale(0.9);
    transform: scale(0.9);
  }
  100% {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
  }
}
@keyframes jet {
  0% {
    -webkit-transform: scale(0.9);
    transform: scale(0.9);
  }
  100% {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
  }
}

</style>
